import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createQueryClient } from "./query-client.ts";
import { applyLanguage } from "./i18n.ts";
import { applyContrast, applyTheme } from "./prefs.ts";
import { router } from "./router.tsx";
import { FeedbackProvider } from "./ui/toast.tsx";
import "./fonts.css";
import "./styles.css";

const client = createQueryClient();

applyContrast();
applyTheme();
applyLanguage();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <FeedbackProvider><RouterProvider router={router} /></FeedbackProvider>
    </QueryClientProvider>
  </StrictMode>,
);
